import AdminBaseDashboard from '../views/AdminBase/AdminBaseDashboard';
import AdminBasePipelines from '../views/AdminBase/AdminBasePipelines';
import AdminBaseCandidates from '../views/AdminBase/AdminBaseCandidates';
import CandidateItem from '../components/Admin/Candidates/CandidateItem';
import AdminBaseJobs from '../views/AdminBase/AdminBaseJobs';
import AdminBaseEmployers from '../views/AdminBase/AdminBaseEmployers';
import JobItem from '@/components/Admin/Jobs/JobItem';
import EmployersItem from '../components/Admin/Employers/EmployersItem';

import EmptyRouterView from '../router/EmptyRouterView';

const url_prefix = process.env.VUE_APP_URL_PREFIX;

export default [
  {
    path: '/user',
    name: 'user',
    redirect: '/user/dashboard',
    meta: {
      requiresAuth: true,
      userAuth: true,
    },
  },
  /* {
        path: url_prefix + '/user/profile',
        name: 'user-profile',
        component: EmployersProfileAdminView,
        meta: {
          requiresAuth: true,
          userAuth: true,
        },
      }, */
  {
    path: '/user/dashboard',
    name: 'user-dashboard',
    component: AdminBaseDashboard,
    meta: {
      requiresAuth: true,
      userAuth: true,
      breadcrumb: 'Dashboard',
    },
  },
  {
    path: '/user/pipelines',
    name: 'user-pipelines',
    component: AdminBasePipelines,
    meta: {
      requiresAuth: true,
      userAuth: true,

      breadcrumb: function() {
        //const { name } = this.$route;
        return 'Pipelines';
      },
    },
  },
  // user/Candidates
  {
    path: '/user',
    component: EmptyRouterView,
    meta: {
      requiresAuth: true,
      userAuth: true,
    },
    children: [
      {
        path: '/user/candidates',
        name: 'user-candidates',
        component: AdminBaseCandidates,
        meta: {
          requiresAuth: true,
          userAuth: true,

          breadcrumb: 'Candidates',
        },
      },
      {
        path: '/user/candidates',
        name: '',
        component: EmptyRouterView,
        meta: {
          requiresAuth: true,
          userAuth: true,

          breadcrumb: '',
        },
        children: [
          {
            path: '/user/candidates/:candidate_id',
            name: 'user-candidate_id',
            component: CandidateItem,
            meta: {
              requiresAuth: true,
              userAuth: true,

              breadcrumb: function() {
                return `${this.$store.getters.getCandidateById.first_name} ${this.$store.getters.getCandidateById.last_name}`;
              },
            },
          },
        ],
      },
    ],
  },
  // user/Jobs
  {
    path: '/user',
    component: EmptyRouterView,
    meta: {
      requiresAuth: true,
      userAuth: true,
    },
    children: [
      {
        path: '/user/jobs',
        name: 'user-user-jobs',
        component: AdminBaseJobs,

        meta: {
          requiresAuth: true,

          userAuth: true,
          breadcrumb: 'Jobs',
        },
      },
      {
        path: '/user/jobs',
        name: '',
        component: EmptyRouterView,
        meta: {
          requiresAuth: true,
          userAuth: true,

          breadcrumb: '',
        },
        children: [
          {
            path: '/user/jobs/:job_uuid',
            name: 'user-job_uuid',
            component: JobItem,
            meta: {
              requiresAuth: true,
              userAuth: true,

              breadcrumb: function() {
                return this.$store.getters.getJobAdById.title;
              },
            },
          },
        ],
      },
    ],
  },
  // user/Employers
  {
    path: '/user',
    component: EmptyRouterView,
    meta: {
      requiresAuth: true,
      userAuth: true,
    },
    children: [
      {
        path: '/user/employers',
        name: 'user-employers',
        component: AdminBaseEmployers,
        meta: {
          requiresAuth: true,
          userAuth: true,

          breadcrumb: 'Employers',
        },
      },
      {
        path: '/user/employers',
        name: '',
        component: EmptyRouterView,
        meta: {
          requiresAuth: true,
          userAuth: true,
        },
        children: [
          {
            path: '/user/employers/:employer_id',
            name: 'user-employer_id',
            component: EmployersItem,
            meta: {
              requiresAuth: true,
              userAuth: true,

              breadcrumb: function() {
                return this.$store.getters.getEmployerById.name;
              },
            },
          },
        ],
      },
    ],
  },
  // Admin Review
  /* {
    path: url_prefix + '/user/review/jobs',
    name: 'user-review-jobs',
    component: AdminBaseReviewJobs,
    meta: {
      requiresAuth: true,
      userAuth: true,

      breadcrumb: function() {
        return 'Review / Jobs';
      },
    },
  },
  {
    path: url_prefix + '/user/review/applications',
    name: 'user-review-applications',
    component: AdminBaseReviewApplications,
    meta: {
      requiresAuth: true,
      userAuth: true,

      breadcrumb: function() {
        return 'Review / Applications';
      },
    },
  }, */
];
